export default "__VITE_ASSET__DF3yxBIU__"